import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { FilteringWrapper } from './style';
import { useRouter } from 'next/router';
import lodashDebounce from 'lodash.debounce';

// Components
import SearchInput from 'components/common/SearchInput';
import DropDown from './DropDown'

// Libs
import Translation from 'libs/Translation';

// Actions
import {getAPI} from 'redux/core/actions';

const Filtering = ({ params, webConfig, name, cities, specialties, educationLevels, pageURL }) => {
    const router = useRouter();
    const dispatch = useDispatch();
    const [searchValue, setSearchValue] = useState({});
    const [finalSpecialties, setFinalSpecialties] = useState([]);
    const [finalCities, setFinalCities] = useState([]);
    const [finalValue, setFinalValue] = useState(name);

    useEffect(() => {
        setFinalCities(cities);
    }, [cities])

    useEffect(() => {
        setFinalSpecialties(specialties);
    }, [specialties])

    useEffect(() => {
        setFinalValue(name ?? '');
    }, [name])

    const handleChange = e => {
        const {value} = e.target;
        setFinalValue(value);
    }

    const handleSearchName = () => {
        let queries = '';
        Object.keys(params)?.forEach((k, index) => {
            queries = `${queries}${k}=${params[k]}`;	
            if (index < Object.keys(params)?.length - 1) {
                queries = `${queries}&`;
            }
        })
        if (finalValue) {
            queries = `${queries}name=${finalValue}`;
        }
        router.push(`${pageURL}?${queries}`);
    }

    const handleSearch = (e) => {
        const {value, name} = e.target;
        const newSearchValue = {name: name, value: value};
        setSearchValue(newSearchValue);

        if (name === 'city') {
            if (value) {
                dispatch(getAPI('getCities', {search: value}, 'nestApi'))
                    .then(res => {
                        setFinalCities(res);
                    })
                    .catch(err => {
                        console.error(err)
                    })
            }
            else {
                setFinalCities(cities);
            }
        }
        else if (name === 'specialty') {
            if (value) {
                dispatch(getAPI('getSpecialties', {SpecialtyType: 'SPECIALTY', search: value, lang: webConfig.lang}, 'nestApi'))
                    .then(res => {
                        setFinalSpecialties(res);
                    })
                    .catch(err => {
                        console.error(err)
                    })
            }
            else {
                setFinalSpecialties(specialties);
            }
        }
    }
    
    const debouncedHandleSearch = lodashDebounce((e) => {handleSearch(e)}, 1000)

    return (
        <FilteringWrapper>
            <SearchInput 
                name='name'
                value={finalValue}
                handleChange={handleChange}
                placeholder={Translation.t('label.doctor-name')}
                searchButton
                handleSearch={handleSearchName}
            />
            <DropDown 
                items={finalCities}
                searchValue={searchValue.city}
                handleSearch={debouncedHandleSearch}
                name="city"
                label={Translation.t('label.city')}
                placeholder={Translation.t('label.city')}
                expand={true}
                searchBar={true}
                specialties={specialties}
                educationLevels={educationLevels}
                cities={cities}
            />
            <DropDown 
                items={finalSpecialties}
                searchValue={searchValue.specialty}
                handleSearch={debouncedHandleSearch}
                name="specialty"
                label={Translation.t('label.specialty')}
                placeholder={Translation.t('label.specialty')}
                expand={true}
                searchBar={true}
                specialties={specialties}
                educationLevels={educationLevels}
                cities={cities}
            />
            <DropDown 
                items={educationLevels}
                name="educationLevel"
                label={Translation.t('label.education-level')}
                placeholder={Translation.t('label.education-level')}
                expand={true}
                specialties={specialties}
                educationLevels={educationLevels}
                cities={cities}
            />
        </FilteringWrapper>  
    )
}

export default Filtering;
